import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from './Button';
import css from './DropdownButton.module.scss';
import ChevronUp from '../Icons/ChevronUp.jsx';
import ChevronDown from '../Icons/ChevronDown.jsx';

const DropdownButton = ({
  children,
  label,
  icon,
  position = 'below',
  align = 'right',
  disabled = false,
  className = '',
  variant,
  size,
  style,
  showExpandableArrows = true,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  const dropdownClasses = [
    css.dropdown,
    position === 'above' ? css.dropdownAbove : css.dropdownBelow,
    align === 'left' ? css.dropdownAlignLeft : css.dropdownAlignRight
  ].filter(Boolean).join(' ');

  const onClick = (e) => {
    e.preventDefault();
    setIsOpen((prev) => !prev);
  }

  const onChildClick = () => {
    setIsOpen(false); // Close the dropdown when a child is clicked
  };


  return (
    <div className={css.dropdownWrapper} ref={wrapperRef} style={style}>
      <Button
        {...props}
        disabled={disabled}
        className={className}
        onClick={onClick}
        icon={icon}
        iconPosition="left"
        variant={variant}
        size={size}
      >
        {showExpandableArrows &&
          <span className={css.content}>
            {label}
            <span className={`${css.dropdownArrow} ${size}`}>
              {position === 'above' ? <ChevronUp width="15px"/> : <ChevronDown width="15px"/>}
            </span>
          </span>
        }
      </Button>

      {isOpen && (
        <div className={dropdownClasses} onClick={onChildClick}>
          {children}
        </div>
      )}
    </div>
  );
};

DropdownButton.propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.node.isRequired,
  icon: PropTypes.node,
  position: PropTypes.oneOf(['above', 'below']),
  align: PropTypes.oneOf(['left', 'right']),
  disabled: PropTypes.bool,
  className: PropTypes.string,
  variant: PropTypes.oneOf([
    'primary',
    'secondary',
    'tertiary',
    'link',
    'success',
    'warning',
    'danger'
  ]),
  size: PropTypes.oneOf(['small', 'default']),
};

export default DropdownButton;
